import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const SOCIALS = {
  instagram: "https://instagram.com/theplusonetribe",
  whatsapp: "https://chat.whatsapp.com/theplusonetribe",
};

export const api = {
  meta: () => axios.get(`${API}/meta`).then((r) => r.data),
  events: (params = {}) => axios.get(`${API}/events`, { params }).then((r) => r.data),
  event: (slug) => axios.get(`${API}/events/${slug}`).then((r) => r.data),
  join: (payload) => axios.post(`${API}/members`, payload).then((r) => r.data),
  book: (payload) => axios.post(`${API}/bookings`, payload).then((r) => r.data),
  booking: (id) => axios.get(`${API}/bookings/${id}`).then((r) => r.data),
};

export const inr = (n) => `\u20B9${Number(n).toLocaleString("en-IN")}`;
export const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
